import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "../data/services";

export const WhatsAppFloat = () => {
    return (
        <motion.a
            data-testid="whatsapp-float-btn"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Contactar con AS Studio por WhatsApp"
            initial={{ scale: 0, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 1.8, type: "spring", stiffness: 200, damping: 15 }}
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.95 }}
            className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-coral text-navy pl-4 pr-6 py-4 rounded-full shadow-2xl shadow-navy/30 font-mono text-xs uppercase tracking-[0.15em] font-semibold"
        >
            <span className="relative flex items-center justify-center">
                <span className="absolute inline-flex w-10 h-10 rounded-full bg-coral animate-pulse-ring" aria-hidden="true" />
                <MessageCircle size={26} className="relative" />
            </span>
            <span className="hidden sm:inline">Hablemos</span>
        </motion.a>
    );
};
